// AUTO-GENERATED -- do not edit manually
// Generated by scripts/generate-app-version.js
export const APP_VERSION = {
  version: '1.63.0',
  buildDate: '2026-11-05T10:09:08Z',
} as const;
